import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BaseResponseSingle } from "../../typings";
import { ICustomerTaxExemptionResponse } from "../../typings/interfaces/responses/customerTaxExemptionResponse";
import {
  ADD_TAX_EXEMPTION,
  DELETE_TAX_EXEMPTION,
  GET_TAX_EXEMPTION_BY_CUSTOMER,
  UPDATE_TAX_EXEMPTION,
} from "../../configs";

export const getTaxExemptionByCustomer = createAsyncThunk(
  "taxExemption/getByCustomer",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponseSingle<ICustomerTaxExemptionResponse>
      >(GET_TAX_EXEMPTION_BY_CUSTOMER(customerId));
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const addTaxExemption = createAsyncThunk(
  "taxExemption/add",
  async (
    payload: { customerId: number; taxId: string; expiryDate: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<
        BaseResponseSingle<ICustomerTaxExemptionResponse>
      >(ADD_TAX_EXEMPTION(payload.customerId), {
        taxId: payload.taxId,
        expiryDate: payload.expiryDate,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const updateTaxExemption = createAsyncThunk(
  "taxExemption/update",
  async (
    payload: { customerId: number; taxId: string; expiryDate: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put<
        BaseResponseSingle<ICustomerTaxExemptionResponse>
      >(UPDATE_TAX_EXEMPTION(payload.customerId), {
        taxId: payload.taxId,
        expiryDate: payload.expiryDate,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deleteTaxExemption = createAsyncThunk(
  "taxExemption/delete",
  async (customerId: number, { rejectWithValue }) => {
    try {
      await axios.delete(DELETE_TAX_EXEMPTION(customerId));
      return customerId;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
